import { render, staticRenderFns } from "./AddressUpdate.vue?vue&type=template&id=a2aefca4&scoped=true"
import script from "./AddressUpdate.vue?vue&type=script&lang=js"
export * from "./AddressUpdate.vue?vue&type=script&lang=js"
import style0 from "./AddressUpdate.vue?vue&type=style&index=0&id=a2aefca4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2aefca4",
  null
  
)

export default component.exports